import React from 'react';

/* Atoms */
import { Icon } from 'js/components/atoms';

export default function Button(props) {
    const {
        className = '',
        theme,
        tag,
        href,
        target,
        rel,
        text,
        icon,
        showText = true,
        ...passProps
    } = props;

    const Tag = tag || (href ? 'a' : 'button');
    const additionalAttributes = href ? { href, target, rel: rel || (target == '_blank' ? 'noreferrer noopener' : null) } : {};
    const classNames = [
        'btn',
        theme ? `btn-${theme}` : '',
        className
    ];

    return (
        <Tag
            className={classNames.filter(className => className !== '').join(' ')}
            title={text}
            {...additionalAttributes}
            {...passProps}
        >
            {showText &&
                <span className="btn__text">
                    {text}
                </span>
            }
            {icon && (
                <div className="btn__icon">
                    <Icon
                        {...{
                            size: 24,
                        }}
                        {...icon}
                    />
                </div>
            )}
        </Tag>
    );
}
